import type { SagaIterator } from 'redux-saga';
import { put, takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import type { ResourceActionCreator, ResourceFailureActionCreator } from '../core/resourceStoreTypes';
import * as actions from './termsActions';
import { getLastSyncDate } from './termsSelectors';
import { transformResponseToTerms, transformTermToRequestData } from './termsTransformers';
import { mkTerm, type TermProps } from './termsTypes';

const mkQcsSyncTermsConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<TermProps>();

const mkResourceConfig = (
  successAction: ResourceActionCreator<TermProps>,
  failureAction: ResourceFailureActionCreator,
) =>
  mkQcsSyncTermsConfig({
    resourceName: 'terms',
    resourceBaseUrl: '/businesses/terms',
    getLastSyncDate,

    transformResponseToResources: transformResponseToTerms,
    transformResourceToRequestData: transformTermToRequestData,
    applyResourceFromCRUDResponse: true,

    successAction,
    failureAction,
  });

export function* getTermsActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.getTermsSuccess, actions.getTermsFailure);
  yield resourceSagaUtils.takeAndDebounce(
    actions.getTerms,
    resourceSagaUtils.qcsSyncGetResources<TermProps>,
    resourceConfig,
  );
}

export function* termsDumpUpdater(resources: TermProps[] = []): SagaIterator {
  yield put(actions.getTermsSuccess({ resources: resources.map(mkTerm) }, { context: 'BUMP_CHANGE_DUMP' }));
}

export function* termsNudgeUpdater(): SagaIterator {
  yield put(actions.getTerms(undefined, { context: 'BUMP_CHANGE_NUDGE' }));
}

export function* createTermsActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.createTermSuccess, actions.createTermFailure);
  yield takeEvery(actions.createTerm.type, resourceSagaUtils.qcsSyncCreateResource<TermProps>, resourceConfig);
}

export function* deleteTermsActionWatcher() {
  const resourceConfig = mkResourceConfig(actions.deleteTermSuccess, actions.deleteTermFailure);
  yield takeEvery(actions.deleteTerm.type, resourceSagaUtils.qcsSyncDeleteResource<TermProps>, resourceConfig);
}

export default [getTermsActionWatcher, createTermsActionWatcher, deleteTermsActionWatcher];
